export const CRM_MEDIA_PUBLIC_HOST =
  process.env["NEXT_PUBLIC_CRM_MEDIA_PUBLIC_HOST"];
